import { defineComponent as _defineComponent } from 'vue'
import { ref, shallowRef, watch, nextTick } from 'vue'
import LeftTabs from '@/layout/LeftTabsLayout.vue'
import MtList from './MtList.vue'
import MtTxt from './MtTxt.vue'
import MtFile from './MtFile.vue'
import Result from './Result.vue'
import { tabNames } from './type'
import { ILeftTab } from '@/layout/type'
import { IMtList } from '@/api/mt/type'
import { useRoute } from '@/router'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const leftTabsRef = shallowRef<InstanceType<typeof LeftTabs>>()
const activeName= ref<tabNames>('txtMT')
const isShowRes = ref(false)

const tabs: ILeftTab[] = [
  {
    name: 'txtMT',
    label: '文本翻译',
    icon: 'icon_mt_txt2'
  },
  {
    name: 'fileMT',
    label: '文件翻译',
    icon: 'icon_mt_file2'
  },
  {
    name: 'listMT',
    label: '结果列表',
    icon: 'icon_result_list',
    hiddenBackground: true
  }
]

function handleChangeTab(name: tabNames) {
  activeName.value = name
}
function handleSetTab(tabKey: string) {
  leftTabsRef.value?.setTab(tabKey)
}

const route = useRoute()
watch(() => route.value, async r => {
  if (r.query && r.query.key !== null) {
    // 保证切换tab在组件设置currentTab后进行
    setTimeout(() => {
      handleSetTab(r.query.key as string)
    },10)
  }
}, { immediate: true })

return { __sfc: true,leftTabsRef, activeName, isShowRes, tabs, handleChangeTab, handleSetTab, route, LeftTabs, MtList, MtTxt, MtFile }
}

})